import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { MAP__field_data } from '@shared/types/types';
import { ENUM__field_connectable_type } from '../../../_base/_methods/ENUM__field_connectable_type';
import { DTO_META__field_info } from '../../../_base/DTO_META__field_info';
import { FIELD__base } from '../../../_base/FIELD__base';
import { DECORATOR__class_serialization_tested } from '../../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../../_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_not_linked } from '../../_base/DECORATOR__field_not_linked';
import { FIELD_PRIMITIVE__string_hash_sha256 } from './FIELD_PRIMITIVE__string_hash_sha256';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__string_hash_ml_asset extends FIELD_PRIMITIVE__string_hash_sha256 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_STRING_HASH_ML_ASSET;

  /*
   *
   */
  static init_field_with_type(ml_asset_type: ENUM__ml_asset_type, options_meta: Partial<DTO_META__field_info> = {}) {
    let out = this.init_as_field({ value: ENUM__string_id_empty.HASH_SHA256, ml_asset_type, values_allowed: [] }, options_meta);

    return out;
  }

  static init_input_with_type(ml_asset_type: ENUM__ml_asset_type, options_meta: Partial<DTO_META__field_info> = {}) {
    let out = this.init_as_input({ value: ENUM__string_id_empty.HASH_SHA256, ml_asset_type, values_allowed: [] }, options_meta);

    return out;
  }

  /*
   * META
   */

  populate_enabled!: boolean;
  ml_asset_type!: ENUM__ml_asset_type;

  /*
   * PROPERTIES
   */
  field_connectable__type() {
    return ENUM__field_connectable_type.STRING_HASH_ML_ASSET;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.get_value();
  }

  get db_filter() {
    return { type: this.ml_asset_type, family: this.meta.node_family, hash_sha256: this.value };
  }

  /*
   *
   */

  constructor() {
    super();

    this.is_empty_allowed = false;
    this.populate_enabled = true;
  }

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.get_value().is_empty_hash_sha256()) return false;

    return super.has_effect_on_generation_runtime(graph);
  }

  /*
   *
   */

  @DECORATOR__field_not_linked()
  store__can_deserialize_from_data(map: MAP__field_data) {
    if (!super.store__can_deserialize_from_data(map)) return false;

    /*
     *
     */
    let type = map.get_or_default('type', this.ml_asset_type);
    if (type != this.ml_asset_type) return false;

    let family = map.get_or_default('family', this.meta.node_family);
    if (family != this.meta.node_family) return false;

    /*
     *
     */

    return true;
  }

  @DECORATOR__field_not_linked()
  store__serialization_keys_list_black(): string[] {
    let out = super.store__serialization_keys_list_black();

    out.push('ml_asset_type');
    out.push('populate_enabled');

    return out as string[];
  }

  /*
   *
   */

  is_equal(other: FIELD__base): boolean {
    if (!(other instanceof FIELD_PRIMITIVE__string_hash_ml_asset)) return false;
    if (this.ml_asset_type != other.ml_asset_type) return false;
    if (this.meta.node_family != other.meta.node_family) return false;
    if (this.value != other.value) return false;

    return true;
  }
}
